import React from 'react'
import { PosSelectCon, PosSelectItem } from './styles'
import { positionArray } from '../../../../Constants/player'

type PosSelectProps = {
  current: string
  onChangePosition: (pos: string) => void
  includeAll?: boolean
}

export const PositionFilters: React.FC<
  React.PropsWithChildren<PosSelectProps>
> = ({ current, onChangePosition, includeAll = true }) => {
  const posTypeObj = includeAll ? ['All', ...positionArray] : positionArray
  return (
    <PosSelectCon>
      {posTypeObj.length > 0 && posTypeObj.map((pos) => (
        <PosSelectItem
          key={pos}
          selected={current === pos}
          onClick={() => onChangePosition(pos)}
        >
          {pos}
        </PosSelectItem>
      ))}
    </PosSelectCon>
  )
}
